module.exports = {
  CHAPTER_TITLE: 'decisionAids:chapterTitle'
};
